import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const currentLang = (i18n.language || 'ar').startsWith('ar') ? 'ar' : 'en';
  const dropdownRef = useRef(null);

  const options = [
    { value: 'ar', label: 'العربية' },
    { value: 'en', label: 'English' },
  ];

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setIsOpen(false);
  };

  // إغلاق القائمة عند النقر خارجها
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div ref={dropdownRef} className="relative w-20">
      {/* الزر */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full px-4 py-1 bg-[var(--sidebar)] text-[var(--sidebar-accent-foreground)] flex justify-between items-center rounded-lg"
      >
        {options.find(o => o.value === currentLang)?.label}
      </button>

      {/* القائمة المنسدلة */}
      {isOpen && (
        <ul className="absolute w-full mt-1 bg-[var(--background2)] rounded-lg shadow-lg z-10 overflow-hidden">
          {options.map((option) => (
            <li
              key={option.value}
              onClick={() => changeLanguage(option.value)}
              className="px-4 py-2 hover:bg-[var(--background)] cursor-pointer text-[var(--sidebar-accent-foreground)]"
            >
              {option.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default LanguageSwitcher;